import React from "react";
import { Box, Paper, Grid } from "@mui/material";
import { CardItem } from "./CardItem";

interface Props {
  RowData: any;
  index: any;
}

export const Card = ({ RowData, index }: Props) => {
  const { notes, notesType, inputBy, inputDate } = RowData;
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row" key={index} xs={10} md={12}>
            <CardItem field="Note Type" value={notesType} />
            <CardItem field="Input By" value={inputBy} />
            <CardItem field="Input Date" value={inputDate} isDateField />
            <CardItem field="Comment" value={notes} asHtml />
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
